export default __webpack_public_path__ + "static/media/ssn.626bebf2.svg";